/**
 * 앱 종료 확인 다이얼로그 store.
 *
 * 홈(/)에서 뒤로가기를 눌렀을 때 즉시 App.exitApp() 을 호출하지 않고
 * 이 store 의 isOpen 을 true 로 만든다. 전역 마운트된 `<ExitConfirmDialog />`
 * (RootLayout 에서 단 한 번 마운트) 가 이 상태를 읽어 컨펌 다이얼로그를 노출한다.
 *
 * dispatchBack 의 `exit-app` 분기에서 호출하므로 React 외부에서도 안전하게
 * 사용할 수 있도록 zustand 의 vanilla API (`useExitConfirm.getState()`) 사용.
 */
import { create } from "zustand";

interface ExitConfirmState {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

export const useExitConfirm = create<ExitConfirmState>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}));
